exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-0677da96]{font-size:.24rem;color:#19191a;padding:.4rem .3rem;text-align:center}.button p span[data-v-0677da96]{color:#2a2aff}button[data-v-0677da96]{background-image:linear-gradient(269deg,#3b414d,#262a32);border-radius:2px;height:.92rem;line-height:.92rem;width:84%;color:#fff;border:none;border-radius:.04rem;font-size:.3rem;vertical-align:bottom;margin:.6rem 0 0 8%;padding:0}.bag[data-v-0677da96]{background:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0677da96","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/pass-status/components/BottomLayout.vue
// module id = 8+8T
// module chunks = 1